<template>
  <div
    class="custom-scrollbar"
    @wheel.stop
    :class="{
      'h-auto': disabled,
      'border-t border-b': wrapped,
      'custom-scrollbar--dark': dark
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    wrapped: Boolean,
    dark: Boolean
  }
};
</script>
<style scoped>
.custom-scrollbar::-webkit-scrollbar-track {
  @apply rounded-xl;
  -webkit-box-shadow: inset 0 0 3px white;
}
.custom-scrollbar::-webkit-scrollbar-button {
  width: 0.25rem;
  height: 0.25rem;
}
.custom-scrollbar {
  @apply scrollbar-thin scrollbar-thumb-brand scrollbar-track-transparent scrollbar-thumb-rounded;
  overflow-y: auto;
}

.custom-scrollbar--dark::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px theme("colors.brand");
}
.custom-scrollbar--dark {
  @apply border-brand scrollbar-thumb-brand;
}
</style>
